import { ALTERAR_DETALHAMENTO_AGENCIA, BUSCAR_AGENCIAS, SELECIONAR_AGENCIA } from '../../actions/types'

const initial = {
  agencias: [],
  agenciaSelecionada: null
}

export default function reducerAgencias (state = initial, action) {
  switch (action.type) {
    case BUSCAR_AGENCIAS: {
      const agencias = action.payload.data;

      if (agencias) {
        return agencias
      }
      return []
    }
    case SELECIONAR_AGENCIA: {
      return {
        ...state,
        agenciaSelecionada: action.payload
      }
    }

    case ALTERAR_DETALHAMENTO_AGENCIA: {
      const { agencia } = action.payload;
      const detalhamento = action.payload.response ? action.payload.response.data : null;
      const indice = state.agencias.indexOf(agencia);
      const nova = Object.assign({}, agencia, { exibirConteudo: !agencia.exibirConteudo });
      const agencias = [...state.agencias];
      agencias[indice] = nova;

      if (detalhamento) {
        agencias[indice].detalhamento = detalhamento;
      }


      return { ...state, agencias };
    }

    default: {
      return state
    }
  }
}
